import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { countrySwitch, categorySwitch, skipSet, dateSwitch } from '../../store/filterSlice';
import { useTranslation } from 'react-i18next';
import Chips from './Chips';
import { getCountryName } from '../../utils/countries';
//import { useLocation } from 'react-router-dom';
import { activityDate2Human } from '../../utils/dateTime';
//
// Компонент для отображения установок фильтра перед списком выдачи результата
//
const FilterInfo = ({ data }) => {
	const { i18n } = useTranslation();
    const dispatch = useDispatch();
	//const location = useLocation();
	const cats = useSelector(state => state.filter.categories);
	const categories = useSelector(state => state.categories);
	const countries = useSelector(state => state.filter.countries);
	const dates = useSelector(state => state.filter.dates);
	const [ categoryList, setCategoryList ] = useState([]);
	const [ countryList, setCountryList ] = useState([]);
	const [ dateList, setDateList ] = useState([]);

	const lang = i18n.language;
	// Перенесли информацию о запросе в ModeSwitch
	// const area = location.pathname.includes('exhibitors') ? 'exhibitors' : 'activities';
	// const count = data?.total ?? 0;
	// const query = data?.find ? data.find.replaceAll('|', ' ').replaceAll('|', ' ') : '';
	// const where = data?.where ?? 'everywhere';

	// Если есть фильтр по категориям, готовим массив для отрисовки
	useEffect(() => {
		const categoryList = [];
		for(let i = 0; i < cats.length; i ++) {
			const cat = categories.find(c => c._id === cats[i]);
			if(cat) categoryList.push({ name: cat.name[lang], id: cat._id });
		}
		categoryList.sort((a, b) => a.name > b.name ? 1 : -1);
		setCategoryList(categoryList);
	}, [ cats, categories, lang ]);

	// Если есть фильтр по странам, готовим массив для отрисовки
	useEffect(() => {
		const countryList = [];
		for(let i = 0; i < countries.length; i ++) {
			const name = getCountryName(countries[i], lang);
			countryList.push({ name, id: countries[i] });
		}
		countryList.sort((a, b) => a.name > b.name ? 1 : -1);
		setCountryList(countryList);
	}, [ countries, lang ]);

	// Если есть фильтр по дням активностей, готовим массив для отрисовки
	useEffect(() => {
		const dateList = [];
		for(let i = 0; i < dates.length; i ++) {
			const name = activityDate2Human(dates[i], lang, false);
			dateList.push({ name, id: dates[i] });
		}
		dateList.sort((a, b) => a.id > b.id ? 1 : -1);
		setDateList(dateList);
	}, [ dates, lang ]);

	// Удаление категории из фильтра по категориям
	const removeCategory = (category_id) => {
		dispatch(categorySwitch(category_id));
		dispatch(skipSet(0));
	};

	// Удаление страны из фильтра по странам
	const removeCountry = (alpha3) => {
		dispatch(countrySwitch(alpha3));
		dispatch(skipSet(0));
	};

	// Удаление дня из фильтра по дням активностей
	const removeDate = (date) => {
		dispatch(dateSwitch(date));
		dispatch(skipSet(0));
	};

	if(!data) return null;

	return (
		<div>
			{/* Перенесли информацию о запросе в ModeSwitch
			<div className='p'>
				{query
				? <div>
					{count
					? t(`${area}.found`, { count, query, where: t('exhibitors.' + where) })
					: t(`${area}.notfound`, { query, where: t('exhibitors.' + where) })}
				</div>
				: <div>
					{count
					? t(`${area}.noquery`, { count })
					: t(`${area}.noqueryfound`)}
				</div>}
			</div>
			*/}

			<div className='p'>
					<Chips list={categoryList} onRemove={removeCategory}/>
					<Chips list={countryList} onRemove={removeCountry}/>
					<Chips list={dateList} onRemove={removeDate}/>
			</div>
		</div>
	);
};

FilterInfo.propTypes = {
	data: PropTypes.shape({
		total: PropTypes.number,
		find: PropTypes.string,
		where: PropTypes.string,
		exhibitors: PropTypes.array,
		activities: PropTypes.array,
	}),
};

export default FilterInfo;
